import { Component, input, TemplateRef, ViewEncapsulation } from '@angular/core';
import { NzEmptyModule } from 'ng-zorro-antd/empty';

@Component({
  selector: 'ui-empty',
  templateUrl: './empty.component.html',
  styleUrl: './empty.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NzEmptyModule],
})
export class UIEmpty {
  image = input<string | TemplateRef<void> | null>('simple');
  content = input<string | TemplateRef<void> | null>();
  footer = input<string | TemplateRef<void>>();
}
